import AppServiceNewApi from "./AppServiceNewApi";

class PayrollService extends AppServiceNewApi{
    constructor(){
        super();
        this.path = '/payroll/'
    }

    getEmployeesActiveTab(organizationId, pagination, filters, isMaxedOut){
        let filterString = '&'
        if(filters?.Employeer)filterString = `${filterString}Employeer=${filters?.Employeer}&`
        if(filters?.StartDateFrom)filterString = `${filterString}StartDateFrom=${filters?.StartDateFrom}&`
        if(filters?.StarDateTo)filterString = `${filterString}StarDateTo=${filters?.StarDateTo}&`
        if(filters?.EmployeeName)filterString = `${filterString}EmployeeName=${filters?.EmployeeName}&`
        if(filters?.StateStatus)filterString = `${filterString}StateStatus=${filters?.StateStatus}&`
        if(filters?.certifiedTargetGroup)filterString = `${filterString}CertifiedTargetGroup=${filters?.certifiedTargetGroup}&`
        if(pagination?.sort)filterString = `${filterString}SortProperty=${pagination?.sort}&`;
        if (pagination?.order && pagination?.sort)filterString = `${filterString}Descending=${pagination?.order}&`;
        if(filters?.targetGroup?.length)filterString = `${filterString}TargetGroup=${filters?.targetGroup}&`
        if(filterString === '&')filterString = ''
        else filterString = filterString.substring(0, filterString?.length - 1)
        const URL = `${this.path}Employees?OrganizationId=${organizationId}&PageNumber=${pagination.page}&PageSize=${pagination.size}${filterString}&MaxedOut=${isMaxedOut}`
        return this.http.get(URL)
    }

    getStateStatus(){
        return this.http.get(`${this.path}Helpers/state-status`)
    }
    
    getPaySchedule(){
        return this.http.get(`${this.path}Helpers/pay-schedules`)
    }

    updateEmploye(id, body){
        return this.http.put(`${this.path}Employees/${id}`, body)
    }

    targetGroups(isForCertfication){
        return this.http.get(`${this.path}TargetGroup/groups?IsForCertfication=${isForCertfication}`)
    }

    downloadFile(organizationId, filters, isMaxedOut, isDetail){
        let filterString = '&'
        if(filters?.Employeer)filterString = `${filterString}Employeer=${filters?.Employeer}&`
        if(filters?.StartDateFrom)filterString = `${filterString}StartDateFrom=${filters?.StartDateFrom}&`
        if(filters?.StarDateTo)filterString = `${filterString}StarDateTo=${filters?.StarDateTo}&`
        if(filters?.EmployeeName)filterString = `${filterString}EmployeeName=${filters?.EmployeeName}&`
        if(filters?.StateStatus)filterString = `${filterString}StateStatus=${filters?.StateStatus}&`
        if(filters?.StateCertification || filters?.StateCertification === false)filterString = `${filterString}StateCertification=${filters?.StateCertification}&`
        if(filters?.targetGroup?.length)filterString = `${filterString}TargetGroup=${filters?.targetGroup}&`
        if(filterString === '&')filterString = ''
        else filterString = filterString.substring(0, filterString?.length - 1);
        const URL = `${this.path}Helpers/download-employees-csv?organizationId=${organizationId}${filterString}&MaxedOut=${isMaxedOut}&includeMontlyData=${isDetail}`
        return this.http.get(URL);
    }
    
    downloadFileByDetail(employeeId ){
        return this.http.get(`${this.path}Helpers/download-employee-ytd-csv?employeeId=${employeeId}`)
    }

    uploadManual(body){
        return this.http.post(`${this.path}Files/upload-manual`, body);
    }

    downloadTemplete(){
        return this.http.get(`${this.path}Helpers/download-payroll-template`)
    }

    getYtdByEmployees(employeeId, year){
        const url = year ? `${this.path}Employees/ytd/${employeeId}?year=${year}` : `${this.path}Employees/ytd/${employeeId}`;
        return this.http.get(url);
    }

    updateHourAndWage(employeeId, body){
        return this.http.put(`${this.path}Employees/manual-data/${employeeId}`, body);
    }

    //invoice summary tab

    getInvoiceSummary(organizationId, year, month){
        return this.http.get(`${this.path}Companies/ytd?organizationId=${organizationId}&year=${year}&month=${month}`)
    }

    updateInvoiceStatus(params){
        const query = `companyId=${params.companyId}&year=${params.year}&month=${params.month}&invoiceSent=${params.invoice}`
        return this.http.put(`${this.path}Companies/ytd/invoice-status?${query}`)
    }

    donwloadExcelForInvoice(organizationId){
        return this.http.get(`${this.path}Helpers/download-employers-csv?organizationId=${organizationId}`)
    }

    getAllInvoice(companyId, page, size){
        return this.http.get(`${this.path}Employees/company/${companyId}/invoice/all?PageNumber=${page}&PageSize=${size}`);
    }

    fetchCertificationTargetGroups(isCertification){
        return this.http.get(`${this.path}TargetGroup/groups?IsForCertfication=${isCertification}`)
    }

    createTargetGroup(body){
        return this.http.post(`${this.path}TargetGroup/create`, body)
    }

    getCompanies(organizationId, params = {}){
        let filterString = '&'
        if(params.ParentCompanyId)filterString = `${filterString}ParentCompanyId=${params.ParentCompanyId}&`
        if(params.Name)filterString = `${filterString}Name=${params.Name}&`
        if(params.ActiveEmployees !== undefined)filterString = `${filterString}ActiveEmployees=${params.ActiveEmployees}&`
        if(filterString === '&')filterString = ''
        else filterString = filterString.substring(0, filterString?.length - 1)
        const URL = `${this.path}Companies?organizationId=${organizationId}&PageNumber=${params.PageNumber || 1}&PageSize=${params.PageSize || 50}${filterString}`
        return this.http.get(URL)
    }
}
export default PayrollService